/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIAddress } from './APIAddress';
import {
    APIAddressFromJSON,
    APIAddressFromJSONTyped,
    APIAddressToJSON,
} from './APIAddress';

/**
 * 
 * @export
 * @interface APIPaginatedAddressList
 */
export interface APIPaginatedAddressList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedAddressList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedAddressList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedAddressList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIAddress>}
     * @memberof APIPaginatedAddressList
     */
    results: Array<APIAddress>;
}

/**
 * Check if a given object implements the APIPaginatedAddressList interface.
 */
export function instanceOfAPIPaginatedAddressList(value: object): value is APIPaginatedAddressList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedAddressListFromJSON(json: any): APIPaginatedAddressList {
    return APIPaginatedAddressListFromJSONTyped(json, false);
}

export function APIPaginatedAddressListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedAddressList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIAddressFromJSON)),
    };
}

export function APIPaginatedAddressListToJSON(value?: APIPaginatedAddressList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIAddressToJSON)),
    };
}

